import { IonButton, IonContent } from "@ionic/react";
import { format } from "date-fns";
import React from "react";
import { useHistory } from "react-router-dom";
import { useRecoilState, useResetRecoilState } from "recoil";
import {
  dummyPatient,
  loggedInUserState,
  newAllDropDownState,
  PatientState,
  resetDropDowns,
} from "../../data/atoms";
import { ActionType, PatientSetting } from "../../models/Enums";
import { getFormatedMobileNumber } from "../../utils/sharedFunction";
interface Props {
  setShowModal1: Function;
  actionType: ActionType;
  reset: Function;
  isEdit: boolean;
}
const CancelModal: React.FC<Props> = ({
  setShowModal1,
  actionType,
  reset,
  isEdit,
}) => {
  let history = useHistory();

  const [patient, setpatientDetails] = useRecoilState(PatientState);
  let [userToEdit, setuserToEditt] = useRecoilState(loggedInUserState);
  const [newAllDropDown, setNewAllDropDown] =
    useRecoilState(newAllDropDownState);
  // const resetList = useResetRecoilState(newAllDropDownState);
  // console.log("actionType modal", actionType)
  const getDatafromId = (id: number) => {
    if (id == 6) {
      return;
    }
    let LookupId: string = PatientSetting[id] as unknown as string;
    return LookupId;
  };
  // console.log(ActionType[actionType])

  return (
    <IonContent placeholder={undefined}>
      <div className="code-resent-modal-custom cancel-modal-custom">
        {actionType === ActionType.ForgotPassword && (
          <>
            <h2 className="forgot-pass-heading">Forgot Password</h2>
            <h4 className="forgot-pass-desc">
              Are you sure you want to exit?<br></br> Any information you
              entered will be cleared.
            </h4>
          </>
        )}
        {actionType === ActionType.SuccessPasswordReset && (
          <>
            <h2 className="forgot-pass-heading">Reset Password</h2>
            <h4 className="forgot-pass-desc">Are you sure you want to exit?</h4>
          </>
        )}
        {actionType === ActionType.EditPatient && (
          <>
            <h2 className="existing-patient-heading">Edit Existing Patient</h2>
            <h4 className="existing-patient-desc">
              Are you sure you want to exit?<br></br> Any new information will
              be cleared.
            </h4>
          </>
        )}
        {actionType === ActionType.CreateNewPatient && (
          <>
            <h2 className="new-patient-heading">Create New Patient</h2>
            <h4 className="new-patient-desc">
              Are you sure you want to exit? The information you entered will be
              cleared.
            </h4>
          </>
        )}
        {actionType === ActionType.EndSession && (
          <>
            {/* <h2 className="end-session-heading">End Session</h2> */}
            <h4 className="end-session-desc">
              Are you sure you want to end this session?<br></br>
              <br></br>Ending the session will take you back to patient search
              page
            </h4>
          </>
        )}
        {actionType === ActionType.NewUser && (
          <>
            <div className="icon-sec text-center">
              <svg
                width="103"
                height="103"
                viewBox="0 0 103 103"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M47.4783 30.4158C49.6994 28.1947 53.3006 28.1947 55.5217 30.4158L72.5842 47.4783C73.6508 48.5449 74.25 49.9916 74.25 51.5C74.25 53.0084 73.6508 54.4551 72.5842 55.5217L55.5217 72.5842C53.3006 74.8053 49.6994 74.8053 47.4783 72.5842C45.2572 70.3631 45.2572 66.7619 47.4783 64.5408L54.8317 57.1875H6C2.85888 57.1875 0.3125 54.6411 0.3125 51.5C0.3125 48.3589 2.85888 45.8125 6 45.8125L54.8317 45.8125L47.4783 38.4592C45.2572 36.2381 45.2572 32.6369 47.4783 30.4158Z"
                  fill="#802392"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.3125 11.6875C0.3125 5.40526 5.40526 0.3125 11.6875 0.3125H91.3125C97.5947 0.3125 102.688 5.40526 102.688 11.6875V91.3125C102.688 97.5947 97.5947 102.688 91.3125 102.688H11.6875C5.40526 102.688 0.3125 97.5947 0.3125 91.3125V79.9375C0.3125 76.7964 2.85888 74.25 6 74.25C9.14112 74.25 11.6875 76.7964 11.6875 79.9375V91.3125H91.3125V11.6875H11.6875V23.0625C11.6875 26.2036 9.14112 28.75 6 28.75C2.85888 28.75 0.3125 26.2036 0.3125 23.0625V11.6875Z"
                  fill="#802392"
                />
              </svg>
            </div>

            <h1>Are you sure you want to exit account setup?</h1>
            <p>Your information will not be saved.</p>
          </>
        )}

        {actionType === ActionType.EditClinician && (
          <>
            <h2 className="end-session-heading">Edit User Profile</h2>
            <h4 className="end-session-desc">
              Are you sure you want to exit? Any information you entered will be
              cleared.
            </h4>
          </>
        )}
        <div className="btn-wrap-sec two-btns">
          <IonButton
            className="generic-btn generic-btn-outline"
            onClick={() => {
              setShowModal1(false);
            }}
            placeholder={undefined}
          >
            Back
          </IonButton>
          <div>
            <IonButton
              className="generic-btn"
              onClick={() => {
                setpatientDetails(dummyPatient);
                actionType == ActionType.EditClinician
                  ? reset({
                      firstname: userToEdit?.firstName,
                      lastname: userToEdit?.lastName,
                      location: userToEdit?.location,
                      username: userToEdit?.username,
                      password:
                        userToEdit?.password == null
                          ? ""
                          : userToEdit?.password,
                      email: userToEdit?.email,
                      country: userToEdit?.country,
                      state: userToEdit?.state,
                      gender: userToEdit?.gender,
                      mobilephone: getFormatedMobileNumber(
                        userToEdit!.mobilePhone
                      ),
                      officephone: userToEdit?.officePhone,
                      address: userToEdit?.address,
                      zip: userToEdit?.zip,
                      role: newAllDropDown?.role?.id,
                    })
                  : actionType == ActionType.EditPatient
                  ? reset({
                      firstname: patient!?.firstName,
                      lastname: patient!?.lastName,
                      nickname: patient!?.nickName,
                      dob: patient!?.dob,
                      email: patient!?.email,
                      zipcode: patient!?.zip,
                      mrn: patient!?.mrn,
                      phone: getFormatedMobileNumber(patient!?.mobilePhone!),
                      setting: getDatafromId(patient!?.patientSetting),
                      referral: patient!?.referralId!,
                      physician: patient!?.physicianId,
                      department: patient!?.departmentId,
                      testPatient: false,
                      dobFormatted:
                        patient?.dob == undefined || patient?.isNew == true
                          ? ""
                          : format(new Date(patient?.dob), "MM/dd/yyyy"),
                    })
                  : reset();
                setShowModal1(false);

                if (
                  actionType === ActionType.ForgotPassword ||
                  actionType === ActionType.SuccessPasswordReset ||
                  actionType === ActionType.NewUser
                ) {
                  localStorage.clear();
                  history.push("/login");
                } else if (
                  actionType === ActionType.CreateNewPatient ||
                  actionType === ActionType.EndSession ||
                  actionType === ActionType.EditPatient
                ) {
                  localStorage.removeItem("iseditingDob");
                  history.replace("/home");
                } else if (actionType === ActionType.EditClinician) {
                  history.push("/user-profile");
                }
              }}
              placeholder={undefined}
            >
              Exit
            </IonButton>
          </div>
        </div>
      </div>
    </IonContent>
  );
};

export default CancelModal;
